module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "dholder"
  }, [(_vm.loading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "some"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 cand-line"
  }, [_c('nko', {
    attrs: {
      "item": _vm.candidate.npo
    }
  })], 1), _vm._v(" "), _c('sep'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 cand-line"
  }, [_c('vk', {
    attrs: {
      "item": _vm.candidate.vk
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('buttons', {
    attrs: {
      "locked": _vm.loading
    },
    on: {
      "ok": _vm.onOk,
      "neok": _vm.onNeok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2062c4fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game.vue
// module id = 49
// module chunks = 0